import { gql } from "@apollo/client";

const GET_LANGUAGES = gql`
  query GetLanguages {
    languages {
      id
      englishName
      realName
      bannerBackground
      placementTest
      cities {
        id
        name
      }
      levels {
        id
        title
        description
        active
      }
      languageCategory {
        id
        name
        order
      }
    }
  }
`;

export default GET_LANGUAGES;
